export default {
  SET_ORDER(state, payload) {
    state.orderDetails = payload;
  },
  SET_SELECTED_ORDER(state, payload) {
    state.selectedOrder = payload;
  },
};
